<template>
  <div class="carousel_content">
    <div class="carousel_content_slide" ref="carousel">
      <slot />
    </div>
    <div class="slide-content__buttons-content">
      <div class="slide-navigation">
        <DEButton
          v-if="showFirstBtn"
          class="button-previous"
          btn-text-variant="black"
          :aria-label="btnAriaLabelPrevious"
          :disabled="prevBtnIsDisabled"
          :btn-variant-disabled="btnPreviousDisableColor"
          :btn-variant-hover="btnPreviousColorHover"
          :btn-variant="btnPreviousColor"
          :btn-text-variant-hover="btnTextPreviousColorHover"
          :btn-text="btnPrevious"
          :styleSlideButtons="styleButtonLoader"
          @btnCallToAction="previous(-1)"
          :btn-outline-color="btnOutlineColor"
        >
          <template v-slot:button-icon>
            <slot name="button-previous"></slot>
          </template>
        </DEButton>
        <slot name="content-buttons"></slot>
        <DEButton
          class="button-next"
          :disabled="btnNextDisable"
          :aria-label="btnAriaLabelNext"
          :btn-variant="btnNextColor"
          :btn-variant-disabled="btnNextDisableColor"
          :btn-text-variant-hover="btnTextNextColorHover"
          :btn-variant-hover="btnNextColorHover"
          btn-text-variant="white"
          :btn-text="btnNext"
          :styleSlideButtons="styleButtonLoader"
          @btnCallToAction="next"
          :btn-outline-color="btnOutlineColor"
        >
          <template v-slot:button-icon>
            <slot name="button-next"></slot>
          </template>
        </DEButton>
      </div>
    </div>
  </div>
</template>

<script>
import { DEButton } from '../Buttons';
import slideMixin from './slideMixin';

export default {
  name: 'Slide',
  components: {
    DEButton,
  },
  props: {
    styleButtonLoader: {
      type: String,
      default: '',
    },
    btnAriaLabelPrevious: {
      type: String,
    },
    btnPreviousDisable: {
      type: Boolean,
      default: false,
    },
    btnAriaLabelNext: {
      type: String,
    },
    btnNextDisable: {
      type: Boolean,
      default: false,
    },
    btnPrevious: {
      type: String,
    },
    btnNext: {
      type: String,
    },
    btnNextColor: {
      type: String,
      required: false,
    },
    btnNextColorHover: {
      type: String,
      required: false,
    },
    btnNextDisableColor: {
      type: String,
      required: false,
    },
    btnPreviousColor: {
      type: String,
      required: false,
    },
    btnPreviousDisableColor: {
      type: String,
      required: false,
    },
    btnPreviousColorHover: {
      type: String,
      required: false,
    },
    btnTextPreviousColorHover: {
      type: String,
      required: false,
    },
    btnTextNextColorHover: {
      type: String,
      required: false,
    },
    onNext: {
      type: Function,
      default: () => true,
    },
    onPrevious: {
      type: Function,
      default: () => true,
    },
    btnOutlineColor: {
      type: String,
    },
    goIntroOnFirstSlide: {
      type: String,
      default: null,
    },
    hideFirstDisabledNext: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [slideMixin],
  mounted() {
    this.slide();
  },
  computed: {
    prevBtnIsDisabled() {
      return this.btnPreviousDisable
        ? this.btnPreviousDisable
        : this.currentSlide === 0 && !this.goIntroOnFirstSlide;
    },
    showFirstBtn() {
      if (
        this.currentSlide == 0 &&
        this.hideFirstDisabledNext &&
        this.prevBtnIsDisabled
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>
